import { Songs } from "./Types";

interface Track {
  sound?: Phaser.Sound.BaseSound;
  sectionIndex: number;
  sequence: string[];
}

export class Jukebox {
  private songs: { [key: string]: string[] } = {};
  private activeTrackIndex: number = 0;
  private tracks: Track[] = [
    {
      sectionIndex: 0,
      sequence: [],
    },
    {
      sectionIndex: 0,
      sequence: [],
    },
  ];

  constructor(readonly scene: Phaser.Scene) {
    this.scene.sound.pauseOnBlur = false;
    this.AddSong(Songs.MAIN_MENU, [
      "main_menu_loop_1",
      "main_menu_loop_1",
      "main_menu_loop_1",
      "main_menu_loop_2",
      "main_menu_loop_1",
      "main_menu_loop_1",
      "main_menu_loop_1",
      "main_menu_loop_3",
    ]);
    this.AddSong(Songs.SONG_1, [
      "song_1_loop_1",
      "song_1_loop_1",
      "song_1_loop_1",
      "song_1_loop_1",
      "song_1_loop_2",
      "song_1_loop_2",
      "song_1_loop_2",
      "song_1_loop_2",
      "song_1_loop_3",
      "song_1_loop_4",
      "song_1_loop_4",
      "song_1_loop_4",
      "song_1_loop_5",
      "song_1_loop_6",
      "song_1_loop_7",
      "song_1_loop_7",
      "song_1_loop_7",
      "song_1_loop_7",
      "song_1_loop_5",
      "song_1_loop_6",
      "song_1_loop_8",
      "song_1_loop_8",
      "song_1_loop_8",
      "song_1_loop_8",
      "song_1_loop_9",
      "song_1_loop_9",
      "song_1_loop_10",
      "song_1_loop_11",
    ]);
  }

  public PlaySong(songKey: string): void {
    if (!this.songs[songKey]) {
      console.warn(`Song with key ${songKey} does not exist.`);
      return;
    }
    this.playSequence(this.songs[songKey]);
  }

  public StopMusic(callback?: () => void): void {
    this.scene.tweens.add({
      targets: this.tracks[this.activeTrackIndex].sound,
      volume: 0,
      duration: 500,
      onComplete: () => {
        this.tracks[this.activeTrackIndex].sound?.off(
          "complete",
          this.playNextSection,
          this,
        );
        this.tracks[this.activeTrackIndex].sound?.stop();
        callback?.();
      },
    });
  }

  public AddSong(songKey: string, sequence: string[]): void {
    this.songs[songKey] = sequence;
  }

  private playMusic(): void {
    this.tracks[this.activeTrackIndex].sound?.destroy();
    this.tracks[this.activeTrackIndex].sound = this.scene.sound
      .add(this.tracks[this.activeTrackIndex].sequence[0])
      .on("complete", () => this.playNextSection(this.activeTrackIndex));
    this.tracks[this.activeTrackIndex].sound?.play({ volume: 0 });
    this.scene.tweens.add({
      targets: this.tracks[this.activeTrackIndex].sound,
      volume: 1,
      duration: 1000,
    });
  }

  private playNextSection(trackIndex: number): void {
    const track = this.tracks[trackIndex];
    if (track.sequence.length > 0) {
      track.sectionIndex++;
      if (track.sectionIndex >= track.sequence.length) {
        track.sectionIndex = 0;
      }
      const sound = track.sequence[track.sectionIndex];
      if (!sound) return;
      this.tracks[trackIndex].sound = this.scene.sound
        .add(sound)
        .on("complete", () => this.playNextSection(trackIndex));
      track.sound?.play();
    }
  }

  private playSequence(sequence: string[]): void {
    if (this.tracks[this.activeTrackIndex].sequence === sequence) return;

    if (!this.tracks[this.activeTrackIndex].sound?.isPlaying) {
      this.tracks[this.activeTrackIndex].sectionIndex = 0;
      this.tracks[this.activeTrackIndex].sequence = sequence;
      this.playMusic();
    } else {
      this.scene.tweens.add({
        targets: this.tracks[this.activeTrackIndex].sound,
        volume: 0,
        duration: 1000,
        onComplete: () => {
          this.tracks[this.activeTrackIndex].sound?.off(
            "complete",
            this.playNextSection,
            this,
          );
          this.tracks[this.activeTrackIndex].sound?.stop();

          this.activeTrackIndex =
            (this.activeTrackIndex + 1) % this.tracks.length;
          this.tracks[this.activeTrackIndex].sectionIndex = 0;
          this.tracks[this.activeTrackIndex].sequence = sequence;
          this.playMusic();
        },
      });
    }
  }
}
